import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";

export const WelcomePopup = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (localStorage.getItem("esther_welcome_seen")) return;
    const t = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(t);
  }, []);

  const close = () => { localStorage.setItem("esther_welcome_seen", "1"); setShow(false); };

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribeNewsletter({ email });
      toast.success("Bienvenue ! Code ESTHER10 activé (-10%)");
    } catch (err) {
      console.error("Newsletter subscription failed:", err);
      toast.error("Inscription impossible pour le moment. Réessayez.");
    }
    close();
  };

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="welcome-popup">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />
      <div className="relative bg-creme max-w-md w-full grid md:grid-cols-2 overflow-hidden shadow-2xl">
        <div className="hidden md:block relative overflow-hidden">
          <img src="https://static.prod-images.emergentagent.com/jobs/b62be457-ebdb-4219-8aac-2fecc3b4b298/images/b8f10a54583cb2a0ad0c0b6ed1754f2b23457f27904b5e98aec3ec9e9b2444ab.png" alt="Esther, fondatrice de La Boutique d'Esther" className="h-full w-full object-cover object-top" />
        </div>
        <div className="p-7 text-center">
          <button onClick={close} className="absolute top-3 right-3 text-encre/60 hover:text-encre" data-testid="welcome-close"><X size={20} /></button>
          <p className="font-serif-el italic text-dore mt-2">Bienvenue chez</p>
          <h3 className="font-display text-2xl text-encre mb-3">La Boutique d'Esther</h3>
          <p className="text-sm text-ardoise mb-1">Profitez de</p>
          <p className="font-display text-4xl text-dore mb-1">-10%</p>
          <p className="text-sm text-ardoise mb-4">sur votre première commande avec le code <b className="text-encre">ESTHER10</b></p>
          <form onSubmit={submit} className="space-y-3">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre email"
              className="w-full border border-dore/30 px-4 py-3 text-sm outline-none focus:border-dore" data-testid="welcome-email" />
            <button className="w-full bg-noir text-white py-3 text-xs uppercase tracking-widest font-semibold hover:bg-ardoise transition-colors" data-testid="welcome-submit">J'en profite</button>
          </form>
          <button onClick={close} data-testid="welcome-dismiss" className="text-xs text-ardoise/60 underline mt-3">Non merci</button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
